var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10151_5506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z",
    stroke: "#969696",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4813 4.06885C11.6397 4.21468 11.7897 4.36468 11.9313 4.51885L13.6376 4.7626C13.9156 5.24541 14.1299 5.76222 14.2751 6.3001L13.2376 7.68135C13.2376 7.68135 13.2564 8.10635 13.2376 8.31885L14.2751 9.7001C14.1306 10.2382 13.9162 10.7551 13.6376 11.2376L11.9313 11.4813C11.9313 11.4813 11.6376 11.7876 11.4813 11.9313L11.2376 13.6376C10.7548 13.9156 10.238 14.1299 9.7001 14.2751L8.31885 13.2376C8.10676 13.2564 7.89344 13.2564 7.68135 13.2376L6.3001 14.2751C5.76199 14.1306 5.2451 13.9162 4.7626 13.6376L4.51885 11.9313C4.36468 11.7855 4.21468 11.6355 4.06885 11.4813L2.3626 11.2376C2.08459 10.7548 1.8703 10.238 1.7251 9.7001L2.7626 8.31885C2.7626 8.31885 2.74385 7.89385 2.7626 7.68135L1.7251 6.3001C1.86963 5.76199 2.08395 5.2451 2.3626 4.7626L4.06885 4.51885C4.21468 4.36468 4.36468 4.21468 4.51885 4.06885L4.7626 2.3626C5.24541 2.08459 5.76222 1.8703 6.3001 1.7251L7.68135 2.7626C7.89344 2.74384 8.10676 2.74384 8.31885 2.7626L9.7001 1.7251C10.2382 1.86963 10.7551 2.08395 11.2376 2.3626L11.4813 4.06885Z",
    stroke: "#969696",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10151_5506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsSettings);
export default __webpack_public_path__ + "static/media/notifications-settings.da26dcfcd3658ccd8fbe2c397bae214d.svg";
export { ForwardRef as ReactComponent };